// extracted by mini-css-extract-plugin
export default {"label":"styles_label__IJxTE","checkbox_container":"styles_checkbox_container__ibzZA","checkbox":"styles_checkbox__OpN4f","icon":"styles_icon__vhnyf"};